import { Link } from '@tanstack/react-router'
import { MessageSquareDiff, Settings, LayoutDashboard, ClipboardList } from 'lucide-react'
import { FEATURES } from '@/shared/lib/featureFlags'
import { cn } from '@/shared/lib/utils'
import { useAuth } from '@/shared/hooks/useAuth'
import { Button } from './ui/button'
import { ThemeToggle } from './ThemeToggle'
import { Separator } from './ui/separator'

interface NavItem {
  label: string
  href: string
  icon: React.ReactNode
  enabled: boolean
}

const NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    href: '/dashboard',
    icon: <LayoutDashboard className="h-4 w-4" />,
    enabled: true,
  },
  {
    label: 'Message Redactor',
    href: '/dashboard/message-redactor',
    icon: <MessageSquareDiff className="h-4 w-4" />,
    enabled: FEATURES.messageRedactor,
  },
  {
    label: 'Jira Toolbelt',
    href: '/dashboard/jira-toolbelt',
    icon: <ClipboardList className="h-4 w-4" />,
    enabled: FEATURES.jiraToolbelt,
  },
]

export function Sidebar() {
  const { user, signOut } = useAuth()

  const visibleItems = NAV_ITEMS.filter((item) => item.enabled)

  return (
    <aside className="flex h-full w-56 flex-col border-r bg-background">
      <div className="p-4">
        <h1 className="text-sm font-semibold tracking-tight text-foreground">
          Personal Dashboard
        </h1>
      </div>
      <Separator />
      <nav className="flex-1 space-y-1 p-2">
        {visibleItems.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            className={cn(
              'flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent hover:text-accent-foreground',
              '[&.active]:bg-accent [&.active]:text-accent-foreground [&.active]:font-medium'
            )}
          >
            {item.icon}
            {item.label}
          </Link>
        ))}
      </nav>
      <Separator />
      <div className="p-2 space-y-1">
        <Link
          to="/settings"
          className="flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent hover:text-accent-foreground [&.active]:bg-accent [&.active]:text-accent-foreground"
        >
          <Settings className="h-4 w-4" />
          Settings
        </Link>
        <div className="flex items-center justify-between px-3 py-2">
          <span className="truncate text-xs text-muted-foreground">{user?.email}</span>
          <ThemeToggle />
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="w-full justify-start text-muted-foreground hover:text-foreground"
          onClick={() => signOut()}
        >
          Sign out
        </Button>
      </div>
    </aside>
  )
}
